import { RootState } from '@/store/main';
import { PageModule } from '@/types/module.types';
import updateHomepageModuleReducerHelper from '../helpers/update-homepage-module-reducer-helper';
import { ProjectStateReducerCreator } from '../types';

const updateHomepageModuleReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    (
      data: { module: PageModule; contentModuleIdsToRemove?: number[]; moduleIdsToRemove?: number[] },
      { dispatch, getState }
    ) => {
      // We are not using the fulfilled state in this case because
      // the fulfilled state will trigger before the saveWorkingProject action is completed
      // because the saveWorkingProject action is a debounced async action,
      // however, we immediately call savingWorkingProject in the pending state
      // so you can use `savingWorkingProject` state if you need to "wait" for this action to complete in your component
      const state = getState() as RootState;

      updateHomepageModuleReducerHelper({ data, dispatch, state });

      return data.module;
    },
    {
      pending: (state) => {
        if (state.workingProject?.homepage) {
          // not this will get reset back to false automatically in the save-project middleware
          // when we call dispatch(saveWorkingProject) at the end if this if statement
          state.savingWorkingProject = true;
        }
      },
      rejected: (_state, action) => {
        console.error(action.error);
      },
    }
  );
};

export default updateHomepageModuleReducer;
